import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { FormField, RadioButton } from "ui";

import { FeedInsertWidth, FeedInsertType } from "../../../../constants";
import { FeedInsertFormValues } from "../FeedInsertForm.types";

import styles from "../FeedInsertForm.module.scss";

const InsertTypeField = () => {
  const { setValue, watch } = useFormContext<FeedInsertFormValues>();

  const insetType = watch("type");

  useEffect(() => {
    if (insetType !== FeedInsertType.SingleMedia) {
      setValue("form", FeedInsertWidth.FullWidth);
    }
  }, [insetType]);

  return (
    <FormField label={"Insert Type"}>
      <div className={styles.form_typeOptionsContainer}>
        <RadioButton
          label={"Single Media"}
          onChange={() => setValue("type", FeedInsertType.SingleMedia)}
          checked={insetType === FeedInsertType.SingleMedia}
        />
        <RadioButton
          label={"Media Slider"}
          onChange={() => setValue("type", FeedInsertType.MultipleMedia)}
          checked={insetType === FeedInsertType.MultipleMedia}
        />
        <RadioButton
          label={"Products Slider"}
          onChange={() => setValue("type", FeedInsertType.Products)}
          checked={insetType === FeedInsertType.Products}
        />
      </div>
    </FormField>
  );
};

export default InsertTypeField;
